import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {StoredFilters} from "app/archivage/common/services/store/store.model";
import {shareReplay} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class StoreFilterService {
  private _defaultValues: StoredFilters = {
    user_archived: false,
    manager_archived: false,
    manager_user_draft: false
  };
  private _store$ = new BehaviorSubject<StoredFilters>(this._defaultValues);

  constructor() { }

  get filters(): Observable<StoredFilters> {
    return this._store$.pipe(shareReplay(1));
  }

  update(filters: StoredFilters) {
    this._store$.next(filters);
  }
}
